/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';

/**
 *
 * @class HelpDemosAction
 *
 * @brief jump to the demos page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class HelpDemosAction extends Action {

  constructor(options: any = null) {

    super({
      key:   'help.demos',
      type:  ActionType.Help_Demos,
      label: 'Video Demos',
      icon:  '<i class="fas fa-video"></i>',
      tip:   'View the video tutorials'
    });

  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[HelpDemosAction] executing...');

    return true;
  }
}
